var i;(function(i){i["simple"]="simple";i["tiled"]="tiled";i["grid"]="grid"})(i||(i={}));var t;(function(i){i["logarithmic"]="logarithmic";i["absolute"]="absolute"})(t||(t={}));export{i as BackgroundTypes,t as TilingStrategies};
